import { useCallback, useEffect, useState, Fragment } from "react";
import {
  Grid,
  Button,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  ButtonContainer,
  StyledTitle,
} from "./EditCategory.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";
import { CategorySchema } from "validations";
import {
  getCategoryInfoRequest,
  deleteCategoryRequest,
  updateCategoryRequest,
} from "api/requests";

export default function EditCategory() {
  const navigate = useNavigate();
  const params = useParams();
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CategorySchema),
    defaultValues: {
      title: "",
      type: "",
    },
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const onSubmit = async (data) => {
    const res = await request({
      url: () => updateCategoryRequest({ id: params.categoryId, ...data }),
    });

    if (res) Toast({ type: "success", title: "ویرایش زیردسته" });
  };

  const handelDelete = async () => {
    const res = await request({
      url: deleteCategoryRequest,
      values: params.categoryId,
    });

    if (res) Toast({ type: "success", title: "حذف" });
    navigate("/category");
  };

  const getCategory = useCallback(async () => {
    let res = await request({
      url: getCategoryInfoRequest,
      values: params.categoryId,
    });
    // setcategoryData(res);

    if (res) {
      reset({
        title: res.title,
        type: res.type,
      });
    }
  }, [request, params.categoryId, reset]);

  useEffect(() => {
    getCategory();
  }, [getCategory]);

  return (
    <DrawerCM title="ویرایش زیردسته">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid> 
          <StyledStack>
            <StyledTitle>ویرایش زیردسته</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  label="سردسته"
                  variant="outlined"
                  fullWidth
                  id="type"
                  {...register("type")}
                  error={Boolean(errors.type)}
                  helpertext={errors.type?.message}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              {/* <Grid item md={6} xs={12} p={1.5}>
                <FormControl fullWidth>
                  <InputLabel id="select-type">سردسته</InputLabel>
                  <Select
                    labelId="select-type"
                    label="سردسته"
                    value={selectedType?.name}
                    defaultValue={categoryData?.type}
                    id="type"
                    {...register("type")}
                    error={Boolean(errors.type)}
                    helpertext={errors.type?.message}
                    readOnly={true}
                    onChange={(e) =>
                      setSelectedType({
                        name: e.target.value,
                      })
                    }
                  >
                    {types?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
              <ButtonContainer>
                <Button
                  color="error"
                  startIcon={<DeleteIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handelShowModal}
                >
                  حذف
                </Button>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handelDelete}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
